import { createContext } from 'react'

const AuthContext = createContext({
  user: null,
})

export default AuthContext